{
  "actionbar.actions": "Åtgärder",
  "actionbar.actionsAvailable": "Åtgärder finns.",
  "actionbar.clearSelection": "Rensa markering",
  "actionbar.selected": "{count, plural, =0 {Inga valda} one {# vald} other {# valda}}",
  "actionbar.selectedAll": "Alla markerade",
  "actionbutton.pending": "väntande",
  "breadcrumbs.more": "Fler artiklar",
  "button.pending": "väntande",
  "calendar.invalidSelection": "{selectedCount, plural, one {Valt datum är inte tillgängligt.} other {Valda datum är inte tillgängliga.}}",
  "combobox.loading": "Läser in...",
  "combobox.loadingMore": "Läser in mer...",
  "combobox.noResults": "Inga resultat",
  "contextualhelp.help": "Hjälp",
  "contextualhelp.info": "Information",
  "datepicker.endTime": "Sluttid",
  "datepicker.startTime": "Starttid",
  "datepicker.time": "Tid",
  "dialog.alert": "Varning",
  "dialog.dismiss": "Avvisa",
  "dropzone.replaceMessage": "Släpp filen för att ersätta",
  "inlinealert.informative": "Information",
  "inlinealert.negative": "Fel",
  "inlinealert.notice": "Varning",
  "inlinealert.positive": "Lyckades",
  "label.(optional)": "(valfritt)",
  "label.(required)": "(krävs)",
  "listview.loading": "Läser in...",
  "listview.loadingMore": "Läser in mer...",
  "menu.loading": "Läser in...",
  "menu.loadingMore": "Läser in mer...",
  "menu.moreActions": "Fler åtgärder",
  "menu.noResults": "Inga resultat",
  "menu.unavailable": "Ej tillgänglig, expandera för mer information",
  "notificationbadge.indicatorOnly": "Ny aktivitet",
  "notificationbadge.plus": "{notifications}+",
  "picker.loading": "Läser in...",
  "picker.loadingMore": "Läser in mer...",
  "picker.placeholder": "Välj…",
  "picker.selectedCount": "{count, plural, =0 {Inga objekt markerade} one {# objekt markerat} other {# objekt markerade}}.",
  "sidepanel.collapse": "Dölj sidopanelen",
  "sidepanel.expand": "Expandera sidopanelen",
  "slider.maximum": "Maximum",
  "slider.minimum": "Minimum",
  "table.cancel": "Avbryt",
  "table.drag": "Dra",
  "table.editCell": "Redigera cell",
  "table.loading": "Läser in...",
  "table.loadingMore": "Läser in mer...",
  "table.resizeColumn": "Ändra storlek på kolumn",
  "table.save": "Spara",
  "table.sortAscending": "Sortera i stigande ordning",
  "table.sortDescending": "Sortera i fallande ordning",
  "tag.actions": "Åtgärder",
  "tag.hideButtonLabel": "Visa mindre",
  "tag.noTags": "Ingen",
  "tag.showAllButtonLabel": "Visa alla ({tagCount, number})",
  "toast.clearAll": "Rensa alla",
  "toast.collapse": "Dölj",
  "toast.showAll": "Visa alla",
  "treeview.loadingMore": "Läser in mer..."
}
